import "./Hero.css";
import heroImage from "../../assets/images/gallery/hero.jpg";

import {
  BsArrowRight,
  BsAwardFill,
  BsGlobeCentralSouthAsia,
  BsCheckCircleFill
} from "react-icons/bs";

function Hero() {
  return (
    <section className="hero" id="home">

      {/* Background Shapes */}

      <div className="hero-circle hero-circle-one"></div>
      <div className="hero-circle hero-circle-two"></div>

      <div className="container-custom">

        <div className="row align-items-center">

          {/* LEFT SIDE */}

          <div className="col-lg-5">

            <div className="hero-content">

              <span className="hero-tag">
                INDUSTRIAL PACKAGING SOLUTIONS
              </span>

              <h1 className="hero-title">

                Packaging Solutions
                <br />

                Built for

                <span> Performance,</span>

                <br />

                <span>Protection & Precision.</span>

              </h1>

              <p className="hero-description">

                With over three decades of industry expertise,
                TIGI Industries manufactures high-performance
                flexible and industrial packaging solutions that
                deliver product protection, operational efficiency,
                and long-term reliability for businesses across India.

              </p>

              <div className="hero-buttons">

                <a
                  href="#products"
                  className="hero-btn hero-btn-primary"
                >
                  Explore Products

                  <BsArrowRight className="ms-2" />

                </a>

                <a
                  href="#contact"
                  className="hero-btn hero-btn-outline"
                >
                  Request Quote
                </a>

              </div>

              <div className="hero-trust">

                <div className="trust-item">

                  <BsCheckCircleFill />

                  <span>Premium Quality</span>

                </div>

                <div className="trust-item">

                  <BsCheckCircleFill />

                  <span>Pan India Delivery</span>

                </div>

                <div className="trust-item">

                  <BsCheckCircleFill />

                  <span>Sustainable Solutions</span>

                </div>

              </div>

            </div>

          </div>

          {/* RIGHT SIDE */}

          <div className="col-lg-7">

            <div className="hero-image-wrapper">

              <img
                src={heroImage}
                alt="TIGI Industries"
                className="hero-image"
              />

              {/* Floating Card 1 */}

              <div className="floating-card top-card">

                <div className="floating-icon">

                  <BsAwardFill />

                </div>

                <div>

                  <h4>30+ Years</h4>

                  <p>Manufacturing Experience</p>

                </div>

              </div>

              {/* Floating Card 2 */}

              <div className="floating-card bottom-card">

                <div className="floating-icon">

                  <BsGlobeCentralSouthAsia />

                </div>

                <div>

                  <h4>Pan India</h4>

                  <p>Reliable Supply Network</p>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* Scroll Indicator */}

      <a href="#about" className="scroll-indicator">

        <span></span>

        Scroll

      </a>

    </section>
  );
}

export default Hero;